import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { Row } from '@zendeskgarden/react-grid'
import { Header, Body } from '@zendeskgarden/react-modals'
import { LG, MD } from '@zendeskgarden/react-typography'
import { Well } from '@zendeskgarden/react-notifications'
import { decideIncidentStatus, localizeIncidentTimestamp } from '../../utils/incident'

import StatusIcon from './StatusIcon'


const StyledModalIconDiv = styled.div`
  margin-right: 10px
`

const StyledModalTitleDiv = styled.div`
  width: 90%
`

const IncidentDetailDiv = styled.div`
  margin-bottom: 6px
  margin-top: 6px
`

const StyledModalHeader = styled.div`
  display: flex
  justify-content: space-between
`

const ModalTextContainer = styled.div`
  margin-bottom: 10px
  margin-top: 10px
`

const PostmortemContainer = styled.div`
  margin-top: 10px
`

const ModalDuration = ({ startedAt, resolvedAt, inTimezone }) => {
  return (
    <StyledModalHeader>
      <MD>{`Started: ${localizeIncidentTimestamp(startedAt, inTimezone)}`}</MD>
      <MD>{`Resolved: ${localizeIncidentTimestamp(resolvedAt, inTimezone)}`}</MD>
    </StyledModalHeader>
  )
}

function hasNonEmptyIncidentUpdates (updates) {
  let substantiveUpdate = false
  if (updates.length > 0) {
    updates.map(update => {
      if (update.attributes.description) {
        substantiveUpdate = true
      }
    })
  }
  return substantiveUpdate
}

const ModalDetails = ({ incidentUpdates, inTimezone }) => {
  const updates = incidentUpdates ? incidentUpdates : []
  return (
    <div>
      <ModalTextContainer>
        <LG>{hasNonEmptyIncidentUpdates(updates) && 'Incident updates:'}</LG>
      </ModalTextContainer>
      {updates.map(update => {
        if (update.attributes.description) {
          return (
            <Well key={update.id}>
              <IncidentDetailDiv>
                <Row>{localizeIncidentTimestamp(update.attributes.createdAt, inTimezone)}:</Row>
                <Row>{update.attributes.description}</Row>
              </IncidentDetailDiv>
            </Well>
          )
        }
      })}
    </div>
  )
}

const Postmortem = ({ postmortem }) => {
  return ( postmortem ?
    <PostmortemContainer>
      <a href={postmortem} target="_blank" rel="noopener noreferrer">View post mortem report</a>
    </PostmortemContainer> :
    <PostmortemContainer>
      <MD>A post-mortem will be provided in the <a href="https://support.zendesk.com/hc/en-us/sections/4405298854426-Service-notifications" target="_blank" rel="noopener noreferrer">Service Notifications</a> section when complete.</MD>
    </PostmortemContainer>
  )
}

const IncidentModalContent = ({ incident, inTimezone }) => {
  const incidentAttr = incident.attributes
  const [incidentDetails, setIncidentDetails] = useState(null)

  useEffect(() => {
    const fetchIncidentDetails = async () => {
      const incidentUrl = `api/ssp/incidents/${incident.id}`
      try {
        const incidentResponse = await fetch(incidentUrl)
        const body = await incidentResponse.json()
        setIncidentDetails(body)
      } catch(e) {
        console.log(e)
      }
    }
    incident && fetchIncidentDetails()
  }, [incident])

  return (
    <div>
      <Header>
        <Row>
          <StyledModalIconDiv>
            <StatusIcon status={decideIncidentStatus(incidentAttr)}/>
          </StyledModalIconDiv>
          <StyledModalTitleDiv>
            <MD>{incidentAttr.name}</MD>
          </StyledModalTitleDiv>
        </Row>
      </Header>
      <Body>
        <Well>
          <ModalDuration
            startedAt={incidentAttr.startedAt}
            resolvedAt={incidentAttr.resolvedAt}
            inTimezone={inTimezone}
          />
          {incidentDetails && <Postmortem postmortem={incidentDetails.data.attributes.postmortem}/>}
        </Well>
        {incidentDetails && <ModalDetails incidentUpdates={incidentDetails.included.filter(i => i.type === "incidentUpdate")} inTimezone={inTimezone}/>}
      </Body>
    </div>
  )
}

export default IncidentModalContent
